@if(data.showPanel && data.fields.length < 1){<ds-modal [modalInput]="alertModalOneConfig" (visibleChange)="dismiss()">
    <ng-container modal-body>
      <div>
        @if(data && data.message && data.message.length > 1){<h6 class="note">{{ 'note' | translate}}</h6>}

        @if(data.htmlMessage.length > 1){<div>
          @for(item of data.htmlMessage; track item){<h6 class="info-text">
              <span [innerHTML]="item.textHtml"></span>
          </h6>}
        </div>}
        @if(data.htmlMessage.length == 0 && data.message.length > 1){<div>
          @if(data.message.length > 1){<div>
            @for(item of data.message; track $index){<h6 class="info-text">
                <span [innerHTML]="item"></span>
            </h6>}
          </div>}
        </div>}
        @if(data.htmlMessage.length == 0 && data.message.length == 1){<div>
          @for(item of data.message; track $index){<h6>
              <span [innerHTML]="item"></span>
          </h6>}
        </div>}
        @if(data.htmlMessage.length == 0 && data.message.length == 0){<div>
          <h6>
              <span [innerHTML]="sanitizerHtml(data.showReviewConfirmContinuePanelText)"></span>
          </h6>
        </div>}
      </div>
    </ng-container>
    <ng-container modal-footer>
      @if(this.data.btnCancelToolTipText!=''){<ds-button [buttonInput]="dismissButtonConfig" (btnClick)="dismiss()"></ds-button>}
      @if(this.data.btnOkToolTipText!=''){<ds-button [buttonInput]="acceptButtonConfig" (btnClick)="accept()"></ds-button>}
      @if(this.data.btnArray.length > 0){@for(item of data.btnArray; track item) {
        <ds-button [buttonInput]="getButtonConfig(item)" (btnClick)="fnSendAction(item.btnAction)"></ds-button>
      }}
    </ng-container>
</ds-modal>}

@if(data.showPanel && data.fields.length > 0){<panel [panelInput]="alertPanelConfig" (close)="dismiss()">
        <div class="border-content__area__white alert-for-import">
            <div>
                <h6 [ngClass]="this.data.btnCancelToolTipText!='' ? 'text-error' : 'text-success'">{{data.message[0]}}</h6>
                <p>{{data.message[1]}}</p>
            </div> 
             <div class="warning-info-container --borderless">
                <ul class="ds-info-text --icon-info --warning">
                    <li>{{data.message[2]}} </li>
                </ul>
            </div>
            <div class="border-content__area__white  status-container__list">
              @for(item of data.fields; track item; let i = $index)
                {<div class="status__list-item --is-border">
                    <div class="status-__list-item-icon">
                        <img [ngClass]="item.status === 'Mapped' ? 'icon-success' : 'icon-error'" [src]="item.icon" alt="">
                        <p>{{item.value}}</p>
                    </div>
                    <div class="--status" [ngClass]="item.status === 'Mapped' ? '--success' : '--incomplete'">
                       <img [src]="ICONS.BULLET" alt="">
                       {{item.status}}
                    </div>
                </div>}
            </div>
        </div>  
    <ng-container panel-footer>
      @if(this.data.btnCancelToolTipText!=''){<ds-button [buttonInput]="fixButtonConfig" (btnClick)="dismiss()"></ds-button>}
      @if(this.data.btnOkToolTipText!=''){<ds-button [buttonInput]="continueButtonConfig" (btnClick)="accept()"></ds-button>}
    </ng-container>
</panel>}